import { MATYPE_OPTIONS } from './math/ma'
import type { FloatInput, IntInput, OutputSpec, SelectInput } from './types'

/** Small builders so a def reads like its TA-Lib signature. */

export const period = (key: string, def: number, label = 'Length', min = 2): IntInput => ({
  key,
  kind: 'int',
  label,
  default: def,
  min,
  max: 100000,
})

export const matype = (key = 'matype', def = 0, label = 'MA type'): SelectInput => ({
  key,
  kind: 'select',
  label,
  default: def,
  options: MATYPE_OPTIONS,
})

export const float = (key: string, def: number, label: string, min?: number, max?: number, step?: number): FloatInput => ({
  key,
  kind: 'float',
  label,
  default: def,
  ...(min !== undefined ? { min } : {}),
  ...(max !== undefined ? { max } : {}),
  ...(step !== undefined ? { step } : {}),
})

export const line = (key: string, label: string, color: string): OutputSpec => ({ key, label, plot: 'line', color })
export const dots = (key: string, label: string, color: string): OutputSpec => ({ key, label, plot: 'dots', color })
export const histogram = (key: string, label: string, color: string, downColor: string): OutputSpec => ({
  key,
  label,
  plot: 'histogram',
  color,
  downColor,
  baseValue: 0,
})

/** TradingView-like defaults, consistent across the library. */
export const COLOR = {
  blue: '#2962FF',
  orange: '#FF6D00',
  purple: '#7E57C2',
  green: '#26A69A',
  red: '#EF5350',
  teal: '#00BCD4',
} as const

/** Candle pattern: the calc emits TA-Lib's signal; the chart draws a dot under the bar (bullish) or over it (bearish). */
export const marker = (key: string, label: string, bullColor: string = COLOR.green, bearColor: string = COLOR.red): OutputSpec => ({
  key,
  label,
  plot: 'marker',
  color: bullColor,
  downColor: bearColor,
})
